import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarAudioCoverageV1Response } from './get-grammar-audio-coverage-v1-response';
import { getGrammarAudioCoverageV1ResponseSchema } from './get-grammar-audio-coverage-v1-response';

export async function getGrammarAudioCoverageV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarAudioCoverageV1Response>> {
  return getRequest<IGetGrammarAudioCoverageV1Response>({
    path: '/sys/grammar/v1/audio/coverage',
    schema: getGrammarAudioCoverageV1ResponseSchema,
    options,
  });
}
